<billing-title>
  Add Payment Details
</billing-title>
<div class="form-container">
  <payment-form [billingSub]="billingSub$ | async" [period]="period" [plan]="plan"></payment-form>
</div>
<pricing-faq></pricing-faq>
